import React, { useState } from 'react';
import { motion } from 'framer-motion';

import FileUploader from '../components/FileUploader';
import UploadReport from '../components/UploadReport';
import Notification from '../components/notification';

const transition = {
  duration: 0.3,
  ease: [0.6, 0.05, -0.01, 0.9],
};

const pageVariants = {
  initial: { scale: 1.3, opacity: 0, transition },
  enter: { scale: 1, opacity: 1, transition },
  exit: { scale: 0, opacity: 0, transition },
};

const Upload = () => {
  const [report, setReport] = useState(null);
  return (
    <motion.div
      initial="initial"
      animate="enter"
      exit="exit"
      variants={pageVariants}
      className="relative bg-white shadow-md rounded-b m-auto p-5"
    >
      <Notification />
      <FileUploader setReport={setReport} />
      {report && <UploadReport report={report} />}
    </motion.div>
  );
};

export default Upload;
